import * as React from 'react'
import { HrWorkerSummaryData } from '@modules/hr/workers/create/steps/hr-worker-summary-data'

export const HrWorkerCreateFormSummaryStep = (): JSX.Element => (
  <div className="pb-2">
    <h4 className="mt-0 text-secondary">Podsumowanie</h4>
    <HrWorkerSummaryData />
  </div>
)
